import { drama } from '../../../../constants/actionTypes';

export default (state = false, action) => {
  switch (action.type) {
    case drama.FETCH_DRAMA_COMMENTS_FAILED:
      return true;

    case drama.FETCH_DRAMA_COMMENTS:
      return false;

    default:
      return state;
  }
};
